import type { Conversation } from "@swift/shared";
import { useStore } from "../lib/store";

export default function RightPanel({ conversation }: { conversation: Conversation }) {
  const users = useStore((s) => s.users);
  const members = conversation.member_ids
    .map((id) => users[id])
    .filter(
      (u): u is NonNullable<typeof u> =>
        u !== undefined && u.status_kind !== "offline",
    )
    .sort((a, b) => a.display_name.localeCompare(b.display_name));

  const headerLabel =
    conversation.kind === "channel"
      ? `# ${conversation.name ?? ""} — leden online (${members.length})`
      : `Online (${members.length})`;

  return (
    <aside className="hidden w-56 shrink-0 border-l border-slate-700 bg-slate-800 lg:block">
      <div className="border-b border-slate-700 px-3 py-2 text-xs uppercase tracking-wide text-slate-400">
        {headerLabel}
      </div>
      {members.length === 0 ? (
        <div className="px-3 py-3 text-xs italic text-slate-500">Niemand online.</div>
      ) : (
        <ul className="py-2">
          {members.map((u) => (
            <li
              key={u.id}
              className="flex items-center gap-2 px-3 py-1 text-sm text-slate-300"
              title={u.status_text ?? ""}
            >
              <span
                className={`h-2 w-2 rounded-full ${
                  u.status_kind === "online"
                    ? "bg-brand-green"
                    : u.status_kind === "away"
                    ? "bg-yellow-500"
                    : "bg-red-500"
                }`}
              />
              <div className="min-w-0 flex-1">
                <div className="truncate">
                  {u.display_name}
                  <span className="ml-1 text-slate-500">@{u.username}</span>
                </div>
                {u.status_text && (
                  <div className="truncate text-xs text-slate-500">{u.status_text}</div>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}
